<article class="bg-white rounded-lg p-10 min-w-sm w-full">
  <div class="flex flex-col gap-12">
    <h2 class="text-lg font-medium sm:text-xl md:text-2xl text-center">
      Create a New Application
    </h2>
    <ng-container *ngComponentOutlet="selectedForm"></ng-container>
  </div>
</article>
